import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import './Login.css';

export default function Login() {
  const { login, authError } = useApp();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy]         = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    await login(email.trim().toLowerCase(), password);
    setBusy(false);
  }

  return (
    <div className="login-screen">
      <div className="login-top">
        <div className="login-eyebrow">Bienestar · Movimiento</div>
        <h1 className="login-title">Gimnasia<br />Consciente</h1>
        <p className="login-author">por María Rosa Poggi</p>
        <div className="login-line" />
      </div>

      <form className="login-form" onSubmit={handleSubmit}>
        <div className="field">
          <label className="field-label">Email</label>
          <input
            className="field-input"
            type="email"
            autoComplete="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="tu@email.com"
          />
        </div>

        <div className="field">
          <label className="field-label">Contraseña</label>
          <input
            className="field-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            placeholder="••••••••"
          />
        </div>

        {authError && <p className="login-error">{authError}</p>}

        <button className="login-btn" type="submit" disabled={busy}>
          {busy ? 'Ingresando…' : 'Ingresar'}
        </button>
      </form>

      <p className="login-footer">
        ¿Problemas para ingresar?{' '}
        <a href="mailto:mariarosapoggi@gmail.com">Contactanos</a>
      </p>
    </div>
  );
}
